import * as api from '../api';
import { ssgFormActions } from '@social-solutions/ssg-forms';
import { push } from 'react-router-redux';

export const fetchTouchpointActions = api.fetchActions('touchpoints', 'fetch-touchpoint-form');
export const submitTouchpointActions = api.fetchActions('touchpoints', 'submit-touchpoint-form');
export const updateTouchpointActions = api.fetchActions('touchpoints', 'update-touchpoint-form');
const zipAutofillActions = api.fetchActions('touchpoints', 'zip-autofill');
export const fetchTouchpointResponsesActions = api.fetchActions('touchpoints', 'fetch-touchpoint-responses');
export const fetchTouchpointResponseActions = api.fetchActions('touchpoints', 'fetch-touchpoint-response');
export const fetchAttachmentActions = api.fetchActions('touchpoints', 'fetch-attachment');

export const actionTypes = {
  ...fetchTouchpointActions.actionTypes,
  ...submitTouchpointActions.actionTypes,
  ...zipAutofillActions.actionTypes,
  ...fetchTouchpointResponsesActions.actionTypes,
  ...fetchTouchpointResponseActions.actionTypes,
  ...fetchAttachmentActions.actionTypes,
  SET_SHOW_VALIDATION: 'touchpoints.set-show-validation',
  UPDATE_SCALAR_ANSWER: 'touchpoints.update-scalar-answer',
  UPDATE_MULTI_SECTION_ANSWER: 'touchpoints.update-multi-section-answer',
  UPDATE_ATTACHMENT_ELEMENT_BEGIN: 'touchpoints.update-attachment-element-begin',
  UPDATE_ATTACHMENT_ELEMENT_FAILURE: 'touchpoints.update-attachment-element-failure',
  ADD_ATTACHMENT_INFO: 'touchpoints.add-attachment-info',
  ADD_ATTACHMENT_CONTENT: 'touchpoints.add-attachment-content',
  CLOSE_CONFIRM_MODAL: 'touchpoints.close-confirm-modal',
  SHOW_CONFIRM_MODAL: 'touchpoints.show-confirm-modal',
  ABANDON_TOUCHPOINT_RESPONSES: 'touchpoints.abandon-responses',
}

export const fetchTouchpointForm = (siteId, programId, touchpointFormId, initialSave, responseId) =>
  api.getThunk(`/sites/${siteId}/programs/${programId}/touchpoint-forms/${touchpointFormId}`, {siteId, programId, touchpointFormId, initialSave, responseId}, fetchTouchpointActions, {id: touchpointFormId});
 
/**
 * Fetch the most recent touchpoint responses within the given parameters and populates recent response data in the store.
 * @param {string} touchpointFormId  Guid.  Guid.  The touchpoint id to fetch.  If this is the empty guid ('00000000-0000-0000-0000-000000000000'), the most recent responses will be fetched across all touchpoint ids.  If this is not the empty guid, the most recent touchpoint responses for the given touchpoint id will be fetched.
 * @param {number} maxRecords  Number.  The maximum number of records to fetch.
 * @param {number} page  Number.  The page of records to fetch.
 * @param {number} perPage  Number.  The amount of records per page to fetch.
 * @param {boolean} fetchAll  Boolean.  Fetch all of the records.  If this is true, this takes priority over maxRecords.
 * @param {string} sortBy String.  What data should this set be sorted on?  (Not necessarily 1:1 with a true column name from the db.)  Default will be a date field.
 * @param {bool} sortAsc Boolean.  If this is true, data is sorted ascending (lowest value to highest value).  If this is false, data is sorted descending.  Default is true for any other sortBy other than date.  For date, the default is descending.
 * @param {string} search filters results based on the form name
 * @param {string} siteId filters the results based on the available site(s) that the response belongs to
 * @param {string} programId filters the results based on the available program(s) that the response belongs to
 * @returns Void.
 */
export const fetchTouchpointResponses = (touchpointFormId, maxRecords, page, perPage, fetchAll, sortBy='date', sortAsc=true, search = "", siteId = null, programId = null) =>
  api.getThunk(`/touchpoint-responses/GetTouchpointResponses`, {
    touchpointFormId, maxRecords, page, perPage, fetchAll, sortBy, sortAsc, search, siteId, programId
  }, fetchTouchpointResponsesActions, {id: touchpointFormId});

export const zipAutofill = (siteId, programId, touchpointFormId, elementId, zip, country) =>
  api.getThunk(`/touchpoint-responses/zip-autofill`, {siteId, programId, zip, country}, zipAutofillActions, {touchpointFormId, elementId});

export const fetchTouchpointResponse = (siteId, programId, touchpointFormId, responseId) =>
  api.getThunk(`/touchpoint-responses/${responseId}`, {siteId, programId, touchpointFormId}, fetchTouchpointResponseActions, {id: responseId});

export const fetchAttachment = (siteId, programId, formId, responseId, elementId, fileId) =>
  api.getStreamThunk(`/touchpoint-responses/attachment?siteId=${siteId}&programId=${programId}&touchpointFormId=${formId}&responseId=${responseId}&elementId=${elementId}&attachmentId=${fileId}`,
    null, fetchAttachmentActions, {id: formId});

export function updateScalarAnswer(touchpointFormId, elementId, value) {
  return {
    type: actionTypes.UPDATE_SCALAR_ANSWER,
    touchpointFormId,
    elementId,
    value
  }
}

export function updateMultiSectionAnswer(touchpointFormId, elementId, value, ...sections) {
  return {
    type: actionTypes.UPDATE_MULTI_SECTION_ANSWER,
    touchpointFormId,
    elementId,
    value,
    sections
  }
}

export function updateNumericAnswer(touchpointFormId, elementId, answer) {
  return {
    type: actionTypes.UPDATE_SCALAR_ANSWER,
    touchpointFormId,
    elementId,
    value: answer
  }
}

export function updateAttachmentElementBegin(touchpointFormId, elementId, fileCount) {
  return{
    type: actionTypes.UPDATE_ATTACHMENT_ELEMENT_BEGIN,
    touchpointFormId,
    elementId,
    fileCount
  }
}

export function addAttachmentInfo(touchpointFormId, elementId, fileId, name, contentType, size) {
  return{
    type: actionTypes.ADD_ATTACHMENT_INFO,
    touchpointFormId,
    elementId,
    fileId,
    name,
    contentType,
    size
  }
}

export function addAttachmentContent(touchpointFormId, elementId, fileId, content) {
  return{
    type: actionTypes.ADD_ATTACHMENT_CONTENT,
    touchpointFormId,
    elementId,
    fileId,
    content
  }
}

export function updateAttachmentElementFailure(touchpointFormId, elementId, err) {
  return{
    type: actionTypes.UPDATE_ATTACHMENT_ELEMENT_FAILURE,
    touchpointFormId,
    elementId,
    err
  }
}

export function setShowValidation(id, show) {
  return {
    type: actionTypes.SET_SHOW_VALIDATION,
    id,
    show
  }
}

export function submitTouchpointForm(siteId, programId, touchpointFormId, responses) {
  var data = {
    SiteId: siteId,
    ProgramId: programId,
    TouchpointFormId: touchpointFormId,
    Answers: responses
  }
  return api.postThunk('/touchpoint-responses', data, submitTouchpointActions, {id: touchpointFormId});
}

export function updateTouchpointForm(siteId, programId, touchpointFormId, responses, responseId) {
  var data = {
    SiteId: siteId,
    ProgramId: programId,
    TouchpointFormId: touchpointFormId,
    Answers: responses,
    TouchpointResponseId: responseId
  }
  return api.postThunk('/touchpoint-responses/edit', data, submitTouchpointActions, {id: touchpointFormId});
}

export function closeConfirmModal(formId) {
  return {
    type: actionTypes.CLOSE_CONFIRM_MODAL,
    id: formId,
  }
}

export function showSubmitConfirmModal(formId) {
  return {
    type: actionTypes.SHOW_CONFIRM_MODAL,
    id: formId
  }
}

export function redirectTo(returnUrl) {
  return (dispatch) => dispatch(push(returnUrl || '/'));
}

export function abandonTouchpointResponses() {
  return {
    type: actionTypes.ABANDON_TOUCHPOINT_RESPONSES
  }
}

export function updateShowValidation(id, showFormValidation) {
  return ssgFormActions.updateShowValidation(id, showFormValidation);
}



// WEBPACK FOOTER //
// src/touchpoints/touchpoints.actions.js